const toHex = (value: number) => value.toString(16).padStart(2, '0');

export function rgbaToHexa(rgba: string) {
  if (!/^rgba?\([^)]+\)$/.test(rgba)) {
    return null;
  }

  const [r, g, b, a] = rgba
    .replace(/^rgba?\(|\s+|\)$/g, '')
    .split(',')
    .map((val, i) => (i === 3 ? Math.round(parseFloat(val) * 255) : parseInt(val, 10)));

  return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(a)}`;
}
